
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { Loading } from '../../../../../Helper/Loading'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import { WorkNameDDL } from '../../../../../Components/CommonDDL/WorkNameDDL'
import DeletePopup from '../../GardenPopup/DeletePopup'
import AddElectricPolePopUp from './Modal/AddElectricPolePopUp'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { LocationDDL } from '../../../../../Components/CommonDDL/LocationDDL'
import { Get_M_ELEC_Piller_Wise_PoleCount_SelectDataAPI, PoleELEMasterDeleteAPI, PoleEleMasterTableDataAPI, PoleMasterGeoLocationDataAPI } from '../../../../../Redux/ElectricalSlice/PoleSlice'
import PoleCounrPopUp from './Modal/PoleCounrPopUp'
import AllPoleMapView from '../../../../../Components/MapView/AllPoleMapView'
import { toastErrorr } from '../../../../../Helper/ToastMessage'

export const ElectricPoleMaster = () => {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")


    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [loader, setloader] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [OpenCount, setOpenCount] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [ShowAllPoleonMap, setShowAllPoleonMap] = useState({
        show: false,
        data: ''
    })

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [LocationName, setLocationName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [PillerID, setPillerID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [PoleID, setPoleID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Designation, setDesignation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [DesignationPopupShow, setDesignationPopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setDesignationPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setrowData(item)
        setDesignationPopupShow(true)
        setapiFlag('Update')
    }

    const handleOnCloseClick = () => {
        setDesignationPopupShow(false)
        handleIsPost()
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setLocationName({
            ...LocationName,
            ID: 0,
            Label: 'Select...',
        })
        setPillerID({
            ...PillerID,
            ID: 0,
            Label: 'Select...',
        })
        setPoleID({
            ...PoleID,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }


    useEffect(() => {
        const data = {
            M_ELEC_PoleID: PoleID?.ID,
            M_ELEC_PillerID: PillerID?.ID,
            M_ELEC_LocationID: LocationName?.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            M_WardID: WardName?.ID,
        }
        dispatch(Get_M_ELEC_Piller_Wise_PoleCount_SelectDataAPI({ data }))
    }, [IsPost, To, IsClear, isSearch, PoleID?.ID, PillerID?.ID, LocationName?.ID, WardName?.ID])

    const { tableData, isLoading } = useSelector(state => state.Get_M_ELEC_Piller_Wise_PoleCount_SelectData)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [Designation.ID])

    const handleDeleteApi = (item) => {

        const data = {
            M_ELEC_PoleID: item.m_eleC_PoleID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleDeleteCloseClick: handleDeleteCloseClick
        }
        dispatch(PoleELEMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.PoleELEMasterDeleteData)

    const handleDeleteCloseClick = () => {
        setDeletePopupShow(!DeletePopupShow)
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleOpenCount = (i) => {
        setrowData(i)
        setOpenCount(!OpenCount)
    }


    let AllPoleDataMap = [];
    let showError = (item => item.latitude === null && item.longitude === null) ? true : false;
    let showMessage = false

    const handleAllPoleLocation = () => {
        setloader(true);
        const data = {
            M_WardID: WardName?.ID,
            M_ELEC_PillerID: PillerID?.ID,
            M_ELEC_LocationID: LocationName?.ID,
            M_UserID: UserID,
            Flag: 'All',
            handleGetMapData: handleGetMapData,
            token: token,
            From: From,
            To: '99999',
        }
        dispatch(PoleEleMasterTableDataAPI({ data }))
    }

    const handleGetMapData = (data) => {
        if (data) {
            data.forEach(item => {
                if (item.latitude !== null && item.longitude !== null) {
                    AllPoleDataMap = [...AllPoleDataMap, item];
                    // showError=false
                    setTimeout(() => {
                        setShowAllPoleonMap({
                            show: true,
                            data: AllPoleDataMap
                        });
                        if (!showMessage) {
                            // toastSuccesss('All locations found successfully');
                            showMessage = true
                        }
                    }, 1000);
                } else {
                    if (!showError) {
                        toastErrorr('Location not found')
                        showError = true;
                    }
                }
            });
        }
        else {
            toastErrorr('Location Data not found')
        }
        setTimeout(() => {
            setloader(false);
            console.log('AllPoleDataMap', AllPoleDataMap)
        }, 1000);
    }

    const handleCloseAllMap = () => {
        setShowAllPoleonMap({
            show: false,
            data: ''
        })
    }

    return (
        <>
            {loader && <Loading />}
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active="pole" listActive="elec0trical" />

                    <div id="" className="content1">
                        <div className="data_mob1">
                            <div className="row m-1 py-1 pb-4 master_border">

                                <div className='col-12 row'>
                                    <div className="col-12 col-lg-5">
                                        <h5 className="ps-1 py-1">Pole Master</h5>
                                    </div>

                                    <div className="col-12 col-lg-3">
                                        <h5 className="ps-1 py-1">Total Count =
                                            <text style={{ color: '#048A8B', fontSize: '18px' }}>
                                                &nbsp;{tableData && tableData.table && tableData.table.length > 0 && tableData.table[0]?.totalCount ? tableData.table[0]?.totalCount : '0'}
                                            </text>
                                        </h5>
                                    </div>

                                    <div className="col-12 col-lg-4 float-end mt-4 pt-1">
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '-2em' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>

                                {/* <div>
                                    <h5 className="ps-1 py-1">Pole Master</h5>
                                    <div className="col-12 col-lg-7 float-end">
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '-2em' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div> */}

                                <div className="row m-0 ">
                                    <div className="col-12 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12">

                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard='0'
                                                        WLable=''
                                                        Type="Electrical"
                                                        APIFlag="ProjectWiseWard"
                                                        IsPost={IsPost}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <LocationDDL
                                                        WardName={WardName}
                                                        LocationName={LocationName}
                                                        setLocationName={setLocationName}
                                                        APIFlag="Master"
                                                        IsPost={IsPost}
                                                    />
                                                </div>

                                                {/* <div className="col-12 col-md-3 col-lg-2">
                                                    <PillerDDL
                                                        PillerID={PillerID}
                                                        setPillerID={setPillerID}
                                                        WardName={WardName}
                                                        LocationName={LocationName}
                                                        APIFlag="Master"
                                                        IsPost={IsPost}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-3 col-lg-2">
                                                    <PoleDDL
                                                        PoleID={PoleID}
                                                        setPoleID={setPoleID}
                                                        WardName={WardName}
                                                        LocationName={LocationName}
                                                        PillerID={PillerID}
                                                        APIFlag="Master"
                                                        IsPost={IsPost}
                                                    />
                                                </div> */}

                                                <div className="col-12 col-md-3 col-lg-2 mt-4">
                                                    {/* <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" > */}

                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                                {
                                                    WardName?.ID != 0 &&
                                                    <div className="col-12 col-lg-4 mt-4 float-end">
                                                        <button type="button"
                                                            disabled={loader}
                                                            className="btn btn-primary float-end mr-2 position-relative"
                                                            onClick={() => handleAllPoleLocation()}
                                                            style={{ overflow: 'visible' }}
                                                        >
                                                            {
                                                                loader ?
                                                                    <>
                                                                        <i className="fas fa-map-marked-alt mx-1" title='View Map'
                                                                            style={{ cursor: 'pointer', color: 'white', fontSize: '16px' }}
                                                                        />
                                                                        Loading
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <i className="fas fa-map-marked-alt mx-1" title='View Map'
                                                                            style={{ cursor: 'pointer', color: 'white', fontSize: '16px' }}
                                                                        />
                                                                        Map
                                                                        {/* <span className="position-absolute badge rounded-pill bg-danger"
                                                                        style={{ top: '-8px', right: '-8px', fontSize: '11px', padding: '4px 7px' }}>
                                                                        {locationData && locationData.table && locationData.table.length > 0
                                                                            ? locationData.table.length
                                                                            : 0}
                                                                    </span> */}
                                                                    </>
                                                            }
                                                        </button>
                                                    </div>
                                                }
                                                {/* <div className="col-12 col-lg-4 float-end mt-4 pt-1">
                                                    <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                                        style={{ color: "white", marginTop: '-2em' }} onClick={handleAddOnClick}
                                                    >
                                                        <text className="ml-2 poppins">Add</text>
                                                    </i>
                                                </div> */}

                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Ward Name</th>
                                                            <th>Location</th>
                                                            <th>Piller No.</th>
                                                            <th>Pole Count</th>
                                                            {/* <th>Piller Count</th> */}
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((i) =>
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{i?.rowNum}</td>
                                                                    <td>{i?.wardName}</td>
                                                                    <td>{i?.locationName}</td>
                                                                    <td style={{ textAlign: 'center' }}>{i?.pillerNo}</td>
                                                                    <td style={{ textAlign: 'center' }}
                                                                        onClick={() => handleOpenCount(i)}
                                                                    >
                                                                        <span className="px-3" style={{ background: '#d3d3d394', padding: 7, borderRadius: 5, cursor: 'pointer' }}>
                                                                            {i?.poleCount}
                                                                        </span>
                                                                    </td>
                                                                    {/* <td></td> */}
                                                                    <td style={{ textAlign: "center", width: '10%' }}>

                                                                        {/* <i className="fas fa-map-marked-alt mx-3" title='View Map'
                                                                            style={{ cursor: 'pointer', color: 'green', fontSize: '16px' }}
                                                                        // onClick={() => handleEditOnClick(i)}
                                                                        >

                                                                        </i> */}

                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(i)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <span>
                                                                            <DeletePopup
                                                                                open={DeletePopupShow}
                                                                                handleDeleteApi={handleDeleteApi}
                                                                                item={i}
                                                                            />
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    DesignationPopupShow ?
                        <AddElectricPolePopUp
                            open={DesignationPopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }

                {
                    OpenCount ?
                        <PoleCounrPopUp
                            open={OpenCount}
                            handleOnCloseClick={handleOpenCount}
                            rowData={rowData}
                            WardName={WardName}
                            LocationName={LocationName}
                        />
                        : <></>
                }

                {
                    ShowAllPoleonMap.show &&
                    <AllPoleMapView
                        ShowAllPoleonMap={ShowAllPoleonMap}
                        handleCloseAllMap={handleCloseAllMap}
                    />
                }

            </div>

        </>
    )
}